module.exports = __webpack_public_path__ + "img/serije.a066402e.png";